export default __webpack_public_path__ + "static/media/70.4cd84c7e.svg";